(() => {
  'use strict';
  const config = document.getElementById('tdt-company-reviews-config');
  if (!config || document.getElementById('tdt-company-reviews-host')) return;
  const en = (document.documentElement.lang || 'de').toLowerCase().startsWith('en');
  const copy = en ? {read:'Read reviews',caption:'Overall reviews for Dark Tenor',reviews:'reviews',close:'Close reviews'} : {read:'Bewertungen lesen',caption:'Gesamtbewertungen zu Dark Tenor',reviews:'Bewertungen',close:'Bewertungen schließen'};
  const host = document.createElement('div');
  host.id = 'tdt-company-reviews-host';
  host.innerHTML = '<div class="tdt-reviews-backdrop" hidden></div><div class="reviews-io-floating-widget" widget-id="s7Xb3EHYF10AwjVN" data-store-name="dark-tenor" lang="'+(en?'en':'de')+'"></div>';
  document.body.append(host);
  let score = '', count = '', wasOpen = false, opener = null, scheduled = false;
  function enhance() {
    scheduled = false;
    const panel = host.querySelector('.FloatingPanel');
    const numbers = panel && panel.querySelectorAll('.cssVar-subheading__number strong');
    if (numbers && numbers.length === 2) { score = numbers[0].textContent.trim(); count = numbers[1].textContent.trim(); }
    const targets = [...document.querySelectorAll('.tdt-cart .cart-trust, .tdt-ticket .opti2-rating, .tdt-ticket .tdt-ticket__rating')];
    if (!targets.length && config.dataset.page === 'concert') {
      const heading = document.querySelector('#MainContent h1');
      if (heading) { let slot = document.getElementById('tdt-company-review-slot'); if (!slot) {slot = document.createElement('div');slot.id='tdt-company-review-slot';heading.after(slot);} targets.push(slot); }
    }
    targets.forEach(target => {
      let control = target.matches('.tdt-review-trigger') ? target : target.querySelector('.tdt-review-trigger');
      if (!control) {
        control = document.createElement('button');control.type='button';control.className='tdt-review-trigger';control.setAttribute('aria-haspopup','dialog');
        if (target.tagName === 'A') { control.classList.add(...target.classList); target.replaceWith(control); }
        else target.replaceChildren(control);
        control.addEventListener('click', () => { const launch=host.querySelector('.R-LauncherButton');if(launch){opener=control;launch.click();}else{window.open('https://www.reviews.io/company-reviews/store/dark-tenor','_blank','noopener');} });
      }
      const concert=control.closest('.tdt-ticket');
      const title=concert?.querySelector('.erlebnis-show-title');
      const reviewSlot=title?.querySelector('[data-tdt-review-slot]')||title;
      if(reviewSlot && control.parentElement!==reviewSlot){if(reviewSlot!==title)reviewSlot.replaceChildren(control);else reviewSlot.append(control);control.classList.add('tdt-review-trigger--hero');}
      const key = score+'|'+count;

      if (control.dataset.ratingKey !== key) {
        control.dataset.ratingKey=key;
        control.innerHTML = score && count ? '<span class="tdt-review-line"><span class="tdt-review-stars" aria-hidden="true">★★★★★</span><strong></strong><span class="tdt-review-count"></span></span><span class="tdt-review-caption"></span>' : '<span class="tdt-review-caption"></span>';
        if(score && count){control.querySelector('strong').textContent=score+' / 5';control.querySelector('.tdt-review-count').textContent=count+' '+copy.reviews;}
        control.querySelector('.tdt-review-caption').textContent=score?(concert?(en?'Excellent show':'Exzellente Show'):copy.caption):copy.read;
      }
    });
    if(panel){
      panel.setAttribute('role','dialog');panel.setAttribute('aria-modal','true');panel.setAttribute('aria-label',copy.caption);
      const header=panel.querySelector('.FloatingPanel__header');
      if(header && !header.querySelector('.tdt-review-panel-caption')){const label=document.createElement('div');label.className='tdt-review-panel-caption';label.textContent=copy.caption;header.append(label);}

      filterReviews(panel);
      const close=panel.querySelector('.R-IconButton--close');if(close)close.setAttribute('aria-label',copy.close);
      const open=panel.classList.contains('isActive');
      if(open !== wasOpen){wasOpen=open;document.body.classList.toggle('tdt-reviews-open',open);host.querySelector('.tdt-reviews-backdrop').hidden=!open;panel.setAttribute('aria-hidden',String(!open));if(open){loadThirdParty(panel);if(close)close.focus();}else if(opener && opener.isConnected)opener.focus();}
    }
  }
  // Filter review cards only; the provider's aggregate rating/count stay untouched.
  function reviewRating(article) {
    const title = article.querySelector('.R-RatingStars__stars')?.getAttribute('title') || '';
    const match = title.match(/^\s*([0-5](?:[.,]\d+)?)\s*(?:Stars?|Sterne?)\s*$/i);
    return match ? Number(match[1].replace(',', '.')) : NaN;
  }
  function filterReviews(panel) {
    panel.querySelectorAll('[role="article"]').forEach(article => {
      const rating = reviewRating(article);
      const card = article.closest('.R-ContentCard') || article;
      const hidden = !Number.isFinite(rating) || rating < 3 || rating > 5;
      if (card.classList.contains('tdt-review-filtered') !== hidden) {
        card.classList.toggle('tdt-review-filtered', hidden);
      }
    });
    const content = panel.querySelector('.FloatingPanel__content');
    if (content && !content.querySelector('.tdt-review-filter-note')) {
      const note = document.createElement('p');
      note.className = 'tdt-review-filter-note';
      note.append(document.createTextNode(en
        ? 'Selected reviews · '
        : 'Ausgewählte Rezensionen · '));
      const link = document.createElement('a');
      link.href = 'https://www.reviews.io/company-reviews/store/dark-tenor';
      link.target = '_blank'; link.rel = 'noopener';
      link.textContent = en ? 'All reviews' : 'Alle Bewertungen';
      note.append(link); content.prepend(note);
    }
  }
  function reviewKey(article) {
    return [article.querySelector('.cssVar-authorName')?.textContent,
      article.querySelector('.R-RatingStars__stars')?.getAttribute('title'),
      article.querySelector('.R-TextBody--xxs.u-textLeft--all')?.textContent]
      .map(value=>(value||'').replace(/\s+/g,' ').trim()).join('|');
  }
  function loadThirdParty(panel) {
    if(host.querySelector('.tdt-review-source-frame'))return;
    const frame=document.createElement('iframe');
    frame.className='tdt-review-source-frame';frame.tabIndex=-1;frame.setAttribute('aria-hidden','true');
    frame.title=en?'Review source':'Bewertungsquelle';
    frame.addEventListener('load',()=>{
      const doc=frame.contentDocument;if(!doc)return;
      const merge=()=>{
        const articles=[...doc.querySelectorAll('[role="article"]')];
        const content=panel.querySelector('.FloatingPanel__content');
        const first=content?.querySelector('[role="article"]');
        if(!articles.length||!first)return;
        const keys=new Set([...content.querySelectorAll('[role="article"]')].map(reviewKey));
        let list=content.querySelector('.tdt-imported-reviews');
        if(!list){list=document.createElement('div');list.className='tdt-imported-reviews';first.parentElement.parentElement.after(list);}
        articles.forEach(article=>{
          const key=reviewKey(article);if(keys.has(key))return;keys.add(key);
          const card=document.importNode(article.parentElement,true);
          card.removeAttribute('tabindex');card.classList.remove('u-cursorPointer');
          card.querySelectorAll('[role="button"],button,.R-DropUpDownMenu-container').forEach(el=>el.remove());
          card.querySelectorAll('img[alt="Custom"]').forEach(el=>el.remove());
          list.append(card);
        });
        if(articles.length>=60)observer.disconnect();
      };
      const observer=new MutationObserver(merge);observer.observe(doc.body,{subtree:true,childList:true});merge();
    });
    frame.srcdoc='<!doctype html><html lang="'+(en?'en':'de')+'"><meta charset="utf-8"><div class="reviews-io-floating-widget" widget-id="KgB8ZF0PEanfN5k9" data-store-name="dark-tenor" lang="'+(en?'en':'de')+'"></div><script src="https://widget.reviews.io/modern-widgets/floating.js"></script></html>';
    host.append(frame);
  }
  function queue(){if(!scheduled){scheduled=true;requestAnimationFrame(enhance);}}
  function close(){const button=host.querySelector('.FloatingPanel.isActive .R-IconButton--close');if(button)button.click();}
  host.querySelector('.tdt-reviews-backdrop').addEventListener('click',close);
  document.addEventListener('keydown',e=>{if(!wasOpen)return;if(e.key==='Escape'){e.preventDefault();close();}if(e.key==='Tab'){const list=[...host.querySelectorAll('.FloatingPanel [tabindex="0"],.FloatingPanel a[href],.FloatingPanel button')].filter(el=>el.getClientRects().length);if(!list.length)return;const first=list[0],last=list[list.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}}});
  new MutationObserver(queue).observe(host,{childList:true,subtree:true,attributes:true,attributeFilter:['class','title']});
  const content=document.getElementById('MainContent');if(content)new MutationObserver(queue).observe(content,{childList:true,subtree:true});
  enhance();
  const script=document.createElement('script');script.src='https://widget.reviews.io/modern-widgets/floating.js';script.async=true;document.body.append(script);
})();

